module.exports = __webpack_public_path__ + "img/sdg11.8d2e684d.svg";